import { render } from "./Accordeon.vue?vue&type=template&id=487b1069"
import script from "./Accordeon.vue?vue&type=script&lang=js"
export * from "./Accordeon.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__